import * as React from 'react';
import { Section3 } from './Section3';
import { Section2 } from './Section2';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';

export interface FooterMainProps extends BaseComponentProps { 
    lang: string;
}
export interface FooterMainState extends BaseComponentState { }

export class FooterMain extends BaseComponent<FooterMainProps, FooterMainState> {

    render() {
        if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
        return (
            <footer id="footer">
                <Section2 lang={this.props.lang} />
                <Section3 lang={this.props.lang}/>
            </footer>
        );
    }
}


// WEBPACK FOOTER //
// ./src/footer/FooterMain.tsx